<section
  class="relative h-full rounded-xl border bg-white/5 backdrop-blur-md shadow-[0_20px_60px_rgba(0,0,0,0.35)] transition-colors duration-300"
  [ngClass]="[
    tightContentSpacing ? 'px-5 pt-5 -pb-1' : 'p-5',
    highlighted ? 'border-[#88D3EE] border-2' : 'border-white/20'
  ]"
>
  @if (iconUrl) { @if (link) {
  <a
    class="group absolute rounded-md focus:outline-hidden focus-visible:ring-2 focus-visible:ring-sky-300/70"
    [class.-right-3]="true"
    [ngClass]="
      iconPosition === 'bottom-center'
        ? 'bottom-1'
        : '-top-5'
    "
    [routerLink]="link"
    [attr.aria-label]="(iconAlt || title) + ' — open'"
  >
    <img
      [src]="iconUrl"
      [alt]="iconAlt || ''"
      class="h-[70px] w-[70px] object-contain drop-shadow-[0_6px_18px_rgba(0,0,0,0.4)] transition-transform group-hover:scale-[1.03] group-active:scale-[0.98]"
      loading="lazy"
    />
  </a>
  } @else {
  <img
    [src]="iconUrl"
    [alt]="iconAlt || ''"
    class="absolute h-[70px] w-[70px] object-contain drop-shadow-[0_6px_18px_rgba(0,0,0,0.4)]"
    [class.-right-3]="true"
    [ngClass]="
      iconPosition === 'bottom-center'
        ? 'bottom-1'
        : '-top-5'
    "
    loading="lazy"
  />
  } }

  <!-- Inline header layout: title and period label on same row -->
  @if (cardHeader) {
  <ng-content select="[card-header]" />
  } @else {
  <div class="flex items-center justify-center gap-4">
    <div class="flex items-center justify-center">
      @if (link) {
      <a
        class="group text-[24px] uppercase tracking-[7.2px] text-white underline-offset-4 hover:underline focus:outline-hidden focus-visible:ring-2 focus-visible:ring-sky-300/70"
        [routerLink]="link"
        [attr.aria-label]="title + ' — open'"
      >
        <span class="font-normal">{{ getTitleParts().firstWord }}</span>
        @if (getTitleParts().rest) {
          <span class="font-bold"> {{ getTitleParts().rest }}</span>
        }
      </a>
      } @else {
      <span class="text-[24px] uppercase tracking-[7.2px] text-white">
        <span class="font-normal">{{ getTitleParts().firstWord }}</span>
        @if (getTitleParts().rest) {
          <span class="font-bold"> {{ getTitleParts().rest }}</span>
        }
      </span>
      }
    </div>
    @if (periodLabel) {
    <div class="flex flex-col gap-1 items-start justify-center">
      <p class="text-[18px] font-normal leading-[22px] text-[#88d3ee]">
        {{ periodLabel }}
      </p>
    </div>
    }
  </div>
  }

  <div class="empty:mt-0" [ngClass]="tightContentSpacing ? '-mt-3' : 'mt-[24px]'">
    <ng-content></ng-content>
  </div>
</section>
